













































































































































import { Box, SecondaryButton, Flex, BaseModal, Button, InputError } from '../../atoms'
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { EmailInputGroup, InputGroup } from '../../molecules'
import { required, email } from 'vuelidate/lib/validators'
import { emailRequired, emailWrongFormat, OTP_REQUIRED } from '../../../utils/errors'
import {
  CHANGE_EMAIL_REQUEST,
  PROFILE_MODULE,
  CHANGE_EMAIL,
  CANCEL_CHANGE_EMAIL
} from '../../../store/modules/profile/constant'
import { REGISTER_MODULE, EMAIL_SERVER_ERROR } from '../../../store/modules/register/constant'
import { mapActions, mapGetters } from 'vuex'
import { ChangeEmailRequest, ChangeEmailPayload } from '../../../store/api/type'
import * as HttpStatus from 'http-status-codes'

@Component({
  components: {
    Box,
    Flex,
    InputGroup,
    EmailInputGroup,
    SecondaryButton,
    BaseModal,
    Button,
    InputError
  },
  computed: {
    ...mapGetters(REGISTER_MODULE, [EMAIL_SERVER_ERROR])
  },
  methods: {
    ...mapActions(PROFILE_MODULE, [CHANGE_EMAIL_REQUEST, CHANGE_EMAIL, CANCEL_CHANGE_EMAIL])
  },
  validations: {
    changeEmail: {
      required,
      email
    },
    otpValue: {
      required
    }
  }
})
export default class EmailBox extends Vue {
  @Prop({ required: false, type: String }) readonly email!: string
  @Prop({ required: false, type: String }) readonly tel!: string
  @Prop({ required: false, type: String }) readonly newEmail!: string
  @Prop({ required: true, type: Boolean }) readonly emailConfirmed!: boolean
  @Prop({ required: true, type: Boolean }) readonly allowChangeEmail!: boolean
  changeEmail = ''
  otpValue = ''
  allowOTP = false
  modalVisible = false
  confirmationModalVisible = false
  cancelModalVisible = false
  changeEmailSuccessModalVisible = false
  error = ''
  changeEmailRequestError = ''
  otpExpired = false

  get emailError(): string {
    const { changeEmail: emailError } = this.$v
    if (this.changeEmailRequestError) {
      return this.changeEmailRequestError
    }
    if (emailError.$error) {
      if (!emailError.required) {
        return emailRequired
      } else if (!emailError.email) {
        return emailWrongFormat
      }
    }
    return ''
  }

  get otpError(): string {
    const { otpValue } = this.$v
    if (this.error) {
      return this.error
    }
    if (otpValue.$error) {
      if (!otpValue.required) {
        return OTP_REQUIRED
      }
    }
    return ''
  }

  get formError(): boolean {
    return this.$v.$error || this.changeEmailRequestError !== '' || this.error !== ''
  }

  @Watch('modalVisible')
  onModalVisible(modalVisible: boolean) {
    this.$nextTick(() => {
      this.$v.$reset()
    })
    if (!modalVisible) {
      this.changeEmail = ''
      this.changeEmailRequestError = ''
      this.otpValue = ''
      this.error = ''
    }
  }

  @Watch('newEmail')
  onNewEmailChange(newEmail: string) {
    if (newEmail && this.changeEmail === '') {
      this.changeEmail = newEmail
      this.modalVisible = true
      this.allowOTP = true
    }
  }

  @Watch('changeEmail')
  onChangeEmailChange() {
    this.changeEmailRequestError = ''
    this.$v.changeEmail.$touch()
  }

  @Watch('otpValue')
  onOtpChange() {
    this.error = ''
  }
  toggleConfirmationModal(): void {
    this.confirmationModalVisible = !this.confirmationModalVisible
  }
  toggleCancelModal(): void {
    this.cancelModalVisible = !this.cancelModalVisible
  }
  toggleChangeEmailSuccessModal(): void {
    this.changeEmailSuccessModalVisible = !this.changeEmailSuccessModalVisible
    if (!this.changeEmailSuccessModalVisible) {
      this.openChangeEmailModal()
      this.$router.go(0)
    }
  }
  openChangeEmailModal(): void {
    if (!this.allowOTP) {
      this.modalVisible = !this.modalVisible
    }
  }
  async submitChangeEmail() {
    if (this.changeEmail == '') {
      return
    }
    const data: ChangeEmailRequest = {
      // eslint-disable-next-line @typescript-eslint/camelcase
      new_email: this.changeEmail
    }
    if (!this.formError) {
      const resp = await (this as any)[CHANGE_EMAIL_REQUEST](data)
      if (resp.code !== 200) {
        this.changeEmailRequestError = resp?.error_message
      } else {
        this.changeEmailRequestError = ''
        this.allowOTP = !this.allowOTP
        this.toggleConfirmationModal()
      }
    }
  }
  async submitOTP() {
    this.$v.$touch()
    if (this.otpValue === '') {
      return
    }
    const payload: ChangeEmailPayload = {
      otp: this.otpValue
    }
    if (!this.formError) {
      const resp = await (this as any)[CHANGE_EMAIL](payload)
      if (resp.code !== HttpStatus.StatusCodes.OK) {
        this.error = resp?.error_message
        if (
          resp.code == HttpStatus.StatusCodes.TOO_MANY_REQUESTS ||
          resp.code == HttpStatus.StatusCodes.REQUEST_TIMEOUT
        ) {
          this.otpExpired = true
        }
      } else {
        this.error = ''
        this.allowOTP = !this.allowOTP
        this.toggleChangeEmailSuccessModal()
      }
    }
  }
  async cancelChangeEmail() {
    const resp = await (this as any)[CANCEL_CHANGE_EMAIL]()
    if (resp.code !== 200) {
      // TODO HANDLE ERROR CASE
    } else {
      this.toggleCancelModal()
      this.changeEmail = ''
      this.allowOTP = false
      this.otpExpired = false
      this.modalVisible = false
    }
  }
}
